module.exports = __webpack_public_path__ + "fonts/DB Heavent Bd v3.2.58c493b1.ttf";